<template>
  <div class="ncrm-last-call-cell">
    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-icon v-bind="props" size="16" :color="iconColor">
          {{ hasCall ? "mdi-phone" : "mdi-phone-outline" }}
        </v-icon>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <span v-if="hasCall" class="ncrm-last-call-cell__date">{{ formattedDate }}</span>
    <span v-else class="ncrm-last-call-cell__empty">—</span>
  </div>
</template>

<script>
// Celula „Ultimul apel" din listele CRM (contacts, leads table, deals table).
// Stari (decizie user, 2026-07-20): verde = exista si apeluri PBX in istoric;
// gri accentuat = doar apeluri logate manual; gri deschis = niciun apel.
export default {
  name: "NcrmLastCallCell",
  props: {
    lastCallAt: { type: String, default: "" },
    hasPbx: { type: Boolean, default: false },
  },
  computed: {
    hasCall() {
      return Boolean(this.lastCallAt);
    },
    iconColor() {
      if (!this.hasCall) return "grey-lighten-1";
      return this.hasPbx ? "success" : "grey-darken-2";
    },
    tooltipText() {
      if (!this.hasCall) return this.$t("ncrm.activity.lastCall.none");
      return this.hasPbx
        ? this.$t("ncrm.activity.lastCall.pbx")
        : this.$t("ncrm.activity.lastCall.manual");
    },
    formattedDate() {
      const parsed = new Date(String(this.lastCallAt).replace(" ", "T"));
      if (Number.isNaN(parsed.getTime())) return String(this.lastCallAt);
      const pad = (value) => String(value).padStart(2, "0");
      return `${pad(parsed.getDate())}.${pad(parsed.getMonth() + 1)}.${parsed.getFullYear()}, ${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.ncrm-last-call-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.ncrm-last-call-cell__date {
  font-size: 0.8rem;
  color: rgba(var(--v-theme-on-surface), 0.62);
}

.ncrm-last-call-cell__empty {
  color: rgba(var(--v-theme-on-surface), 0.38);
}
</style>
